module.exports = __webpack_public_path__ + "img/centenaryinstitute.c8d14ff.png";